import type { PublicSlotKey } from '#packages/apilib';
import type { RtlLtrSettingsManagerApi } from './rtlLtrSettingsManagerApi';

export const RtlLtrSettingsManagerKey: PublicSlotKey<RtlLtrSettingsManagerApi> =
  {
    name: 'RtlLtrSettingsManager',
    public: true,
  };
